export default __webpack_public_path__ + "static/media/dalenfront.121ff9a0.jpg";